module.exports = __webpack_public_path__ + "static/media/customerBreadCrumb.c83606e5.svg";